/**
 * Created by efowler on 11/24/13.
 */
'use strict';

frontendApp.filter('ucwords', [function () {

  return function (str) {
    return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
      return $1.toUpperCase();
    });
  };

}]);
